import { isString } from "@payair/e-com-common-sdk/core/Validators";
import { MUST_BE_STRING, validateParam } from "../core/Helpers";
export var validateGooglePaySelectionOption = function (googlePaySelectionOption) {
    var errorMessage = [];
    // id: string
    var id = validateParam(googlePaySelectionOption.id, "id", isString(googlePaySelectionOption.id), true, MUST_BE_STRING);
    id && errorMessage.push(id);
    // label: string
    var label = validateParam(googlePaySelectionOption.label, "label", isString(googlePaySelectionOption.label), true, MUST_BE_STRING);
    label && errorMessage.push(label);
    // description?: string | undefined
    var description = validateParam(googlePaySelectionOption.description, "description", isString(googlePaySelectionOption.description), false, MUST_BE_STRING);
    description && errorMessage.push(description);
    return errorMessage.length === 0 ? null : errorMessage.join(", ");
};
